export default __webpack_public_path__ + "static/media/about.8811d977.png";